import { Component, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router'
import { IonRouterOutlet } from '@ionic/angular'
import { Page } from 'src/app/core/page'
import { GeneralService } from 'src/app/services/general/general.service'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { LogService } from 'src/app/services/log/log.service'
import { ModalService } from 'src/app/services/modal/modal.service'
import { RouterService } from 'src/app/services/router/router.service'
import { personalData, service } from './terms'

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
})
export class TermsComponent extends Page implements OnInit {
  screenName = 'terms'
  type: 'service' | 'personal' = 'service'

  constructor(
    protected generalService: GeneralService,
    protected routerService: RouterService,
    protected routerOutlet: IonRouterOutlet,
    protected modalService: ModalService,
    protected title: Title,
    protected logService: LogService,
    protected localeService: LocaleService,
    private activatedRoute: ActivatedRoute
  ) {
    super(generalService, routerService, routerOutlet, modalService, title, logService, localeService)
  }

  serviceTerms: { title: string; desc: string }[] = []
  personalTerms: { title: string; subtitle: string; desc: string }[] = []

  ngOnInit(): void {
    this.setTitle('소셜 플레이그라운드')
    const typeParam: string | null = this.activatedRoute.snapshot.paramMap.get('type')
    if (typeParam === 'service' || typeParam === 'personal') {
      this.type = typeParam
    }
    this.serviceTerms = service[this.localeService.locale]
    this.personalTerms = personalData[this.localeService.locale]
  }
}
